import type { LDContext } from "launchdarkly-js-client-sdk";
import { useEffect, useState } from "react";

import { MBMessageTypes, useCubeMessenger } from "../../iframe";

/**
 * Retrieves the LD context from the parent container when embedded in an iframe
 * and return it when it's received
 */
export const useRetrieveLDContext = () => {
  const [ldContext, setLDContext] = useState<LDContext | null>(null);
  const { sendMessage } = useCubeMessenger({
    handlers: {
      [MBMessageTypes.sendLDContext]: payload => {
        setLDContext(payload);
      },
    },
  });

  useEffect(() => {
    sendMessage({ type: MBMessageTypes.requestLDContext });
  }, [sendMessage]);

  return ldContext;
};
